
import './App.scss';
import { Routes, Route } from 'react-router-dom';
import ResultPage from './pages/ResultPage';
import { Interview } from './pages/InterviewPage';
import PermissionCheck from './pages/PermissionCheck';
import AssessmentFeedback from './pages/Feedback';

function App() {
  return (
    <Routes>
      <Route path="/" element={<PermissionCheck />} />
      <Route path="/interview/:encryptId" element={<Interview />} />
      <Route path="/result/:sessionId" element={<ResultPage />} />
      <Route path="/feedback/:sessionId" element={<AssessmentFeedback />} />
    </Routes>
  );
}

export default App;